// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__T5mLO","boxTitle":"Qualiphy_boxTitle__3GQLg","box":"Qualiphy_box__2z_qa","toggleWrap":"Qualiphy_toggleWrap__2U41A"};